<template>
  <v-app>
    <v-app-bar app color="white" height="70">
      <!-- <v-avatar class="mr-3" color="grey lighten-5" size="70">
        <v-img
          contain
          max-height="70%"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
        ></v-img>
      </v-avatar> -->

      <v-toolbar-title class="font-weight-black headline">LGTM LLC.</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            :src="require('@/assets/bg4.jpg')"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row align="center" class="white--text mx-auto" justify="center">
                  <v-col class="white--text text-center" cols="12" tag="h1">
                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                      class="font-weight-black"
                    >LGTM LLC.</span>

                    <br />
                    <br />

                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                      class="font-weight-light"
                    >ソフトウェア開発 / データ分析・AI</span>

                    <br />
                    <br />

                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                      class="font-weight-light"
                    >デザイン制作・UI/UX</span>
                    <br />
                    <br />
                  </v-col>

                  <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo('#features')">
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>

      <!-- <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">ABOUT</h2>

          <v-responsive class="mx-auto mb-8" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >Vuetify is the #1 component library for Vue.js and has been in active development since 2016. The goal of the project is to provide users with everything that is needed to build rich and engaging web applications using the Material Design specification. It accomplishes that with a consistent update cycle, Long-term Support (LTS) for previous versions, responsive community engagement, a vast ecosystem of resources and a dedication to quality components.</v-responsive>

          <v-avatar class="elevation-12 mb-12" size="128">
            <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
          </v-avatar>

          <div></div>

          <v-btn color="grey" href="https://vuetifyjs.com" outlined large>
            <span class="grey--text text--darken-1 font-weight-bold">Vuetify Documentation</span>
          </v-btn>
        </v-container>

        <div class="py-12"></div>
      </section> -->

      <section id="features" class="grey lighten-3">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">FEATURES</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col v-for="({ icon, title, text }, i) in features" :key="i" cols="12" md="4">
              <v-card class="py-12 px-4" color="grey lighten-5" flat>
                <v-theme-provider dark>
                  <div>
                    <v-avatar color="error" size="88">
                      <v-icon large v-text="icon"></v-icon>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="title"
                ></v-card-title>

                <v-card-text class="subtitle-1" v-text="text"></v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          :src="require('@/assets/bg6.jpg')"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col v-for="[value, title] of stats" :key="title" cols="12" md="12">
                <div class="text-center">
                  <div class="display-3 font-weight-black mb-4" v-text="value"></div>

                  <div class="title font-weight-regular text-uppercase" v-text="title"></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <!-- <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Blog</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col v-for="({ src, text, title }, i) in articles" :key="i" cols="12" md="4">
              <v-img :src="src" class="mb-4" height="275" max-width="100%"></v-img>

              <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3>

              <div class="title font-weight-light mb-5" v-text="text"></div>

              <v-btn class="ml-n4 font-weight-black" text>Continue Reading</v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section> -->

      <v-sheet id="contact" color="#333333" dark tag="section" tile>
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">会社概要</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-theme-provider light>
            <v-data-table
              :headers="comHeaders"
              :items="comVals"
              hide-default-header
              hide-default-footer
              class="elevation-1 pa-md-4 pa-lg-10"
            ></v-data-table>
          </v-theme-provider>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-content>

    <v-footer class="justify-center" color="#292929" height="70">
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >&copy; {{ (new Date()).getFullYear() }} — LGTM LLC.</div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    articles: [
      // {
      //   src: "",
      //   title: "",
      //   text: "",
      // },
    ],
    features: [
      {
        icon: "mdi-desktop-mac-dashboard",
        title: "ソフトウェア開発",
        text:
          "各種ソフトウェア開発、システム開発及びWebサイト開発を行っております。外部サービス連携アプリケーションやChatBotなどの開発も可能です。主要言語: Golang, Python, Ruby, PHP, JavaScript",
      },
      {
        icon: "mdi-brain",
        title: "データ分析・AI",
        text:
          "データ活用のためのデータ分析基盤構築からデータ可視化、ダッシュボードの作成、ML(機械学習)やDeepLearningを利用したAI開発を行っております。画像、自然言語、地図、株価など多様なデータを利用いただけます。主要ツール: TensorFlow, Keras, Pandas, Numpy, Scipy, Elasticsearch",
      },
      {
        icon: "mdi-adobe",
        title: "デザイン制作",
        text:
          "Webデザインを中心にグラフィックデザイン、デジタルサイネージ、AR/VRなど制作しております。フロントエンドの開発に加え、WebGL, ThreeJS, D3.jsを利用したデザインなども行っております。",
      },
    ],
    stats: [
      ["7 Aug 2020", "Established"],
    ],
    comHeaders: [
      { text: "", value: "key" },
      { text: "", value: "val" },
    ],
    comVals: [
      {
        key: "会社名",
        val: "LGTM合同会社",
      },
      {
        key: "設立日",
        val: "2020年8月7日",
      },
      {
        key: "事業内容",
        val: "ソフトウェア/Webサービス開発, デザイン制作",
      },
      {
        key: "代表",
        val: "本多浩司",
      },
      // {
      //   key: "役員",
      //   val: "山口佳織",
      // },
      // {
      //   key: "所在地",
      //   val: "東京都港区台場二丁目２番２号",
      // },
      {
        key: "メールアドレス",
        val: "info@lgtm-tech.com",
      },
    ],
  }),
};
</script>

<style scoped>
.v-data-table
  /deep/
  tbody
  /deep/
  tr:hover:not(.v-data-table__expanded__content) {
  background: #ffffff !important;
}
</style>